export default "__VITE_ASSET__CyyGoOLr__"